export default "__VITE_ASSET__8aSHPqEZ__"